export const formBuilderV3Elements = [
  {
    name: 'text',
    caption: 'Text',
    icon: './input-text-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'text',
      label: 'Text ',
      type: 'text',
      value: 'Das ist ein Beispieltext',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        placeholder: 'Text',
        description: null,
        pattern: '',
        errorMessage: '',
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'number',
    caption: 'Zahl',
    icon: './input-number-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'zahl',
      label: 'Zahl ',
      type: 'number',
      value: 1,
      settings: {
        prefixIcon: { icon: null, linkType: null },
        placeholder: '1',
        description: null,
        max: null,
        min: null,
        step: null,
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'formated number',
    caption: 'formatierte Zahl',
    icon: './number.svg',
    visibility: 'everyone',
    element: {
      name: 'formatiertezahl',
      label: 'formatierte Zahl ',
      type: 'formatted_number',
      value: 1,
      settings: {
        prefixIcon: { icon: null, linkType: null },
        toFixed: 2,
        decSep: ',',
        thSep: '.',
        placeholder: '1',
        description: null,
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'email',
    caption: 'E-Mail-Adresse',
    icon: './mail.svg',
    visibility: 'everyone',
    element: {
      name: 'email',
      label: 'Email ',
      type: 'email',
      value: 'info@codelos.io',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        placeholder: 'Email',
        description: null,
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'file',
    caption: 'Datei & Medien',
    icon: './file.svg',
    visibility: 'everyone',
    element: {
      name: 'file',
      label: 'File ',
      type: 'file',
      value: '',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        description: null,
        required: true,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'date',
    caption: 'Datum',
    icon: './date.svg',
    visibility: 'everyone',
    element: {
      name: 'datum',
      label: 'Datum',
      type: 'date',
      value: '2025-01-01',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        description: null,
        required: true,
        default: false,
        todayAsDefaultValue: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'datetime-local',
    caption: 'Datum & Uhrzeit',
    icon: './datetime.svg',
    visibility: 'everyone',
    element: {
      name: 'datumuhrzeit',
      label: 'Datum & Uhrzeit ',
      type: 'datetime-local',
      value: '2025-01-01T01:00',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        description: null,
        required: true,
        default: false,
        todayAsDefaultValue: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'time',
    caption: 'Zeit',
    icon: './datetime.svg',
    visibility: 'everyone',
    element: {
      name: 'zeit',
      label: 'Zeit',
      type: 'time',
      value: '12:00',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        description: null,
        required: true,
        default: false,
        todayAsDefaultValue: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'textarea',
    caption: 'Großer Text',
    icon: './input-textarea-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'textfeld',
      label: 'Großer Text ',
      type: 'textarea',
      value: 'Das ist ein Beispieltext in einem Textfeld.',
      settings: {
        prefixIcon: { icon: null, linkType: null },
        placeholder: 'Textfeld',
        description: null,
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'textblock',
    caption: 'Paragraph',
    icon: './input-paragraph-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'textblock',
      label: 'Dies ist ein Beispieltext in einem Textblock.',
      type: 'textblock',
      value: '',
      settings: {
        layoutItem: true,
        required: false,
      },
    },
  },
  {
    name: 'hidden',
    caption: 'hidden',
    icon: './hidden.svg',
    visibility: 'everyone',
    element: {
      name: 'hidden',
      label: 'hidden ',
      type: 'hidden',
      value: 'Verstecktes Feld',
      settings: {
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
      },
    },
  },
  {
    name: 'title',
    caption: 'Titel',
    icon: './title.svg',
    visibility: 'everyone',
    element: {
      name: 'title',
      label: 'Titel  ',
      type: 'title',
      value: '',
      settings: {
        layoutItem: false,
        required: false,
        default: true,
        prefixIcon: { icon: null, linkType: null },
      },
    },
  },
  {
    name: 'radio',
    caption: 'Optionsfeld',
    icon: './options.svg',
    visibility: 'everyone',
    element: {
      name: 'option',
      label: 'Option ',
      type: 'radio',
      value: 'Wert1',
      options: [
        { label: 'option 1', value: 'Wert1', checked: true },
        { label: 'option 2', value: 'Wert2', checked: false },
      ],
      settings: {
        layoutItem: false,
        prefilled: true,
        showVerticle: true,
        tooltip: '',
      },
    },
  },
  {
    name: 'radiooval',
    caption: 'Optionskasten',
    icon: './radiocard.svg',
    visibility: 'everyone',
    element: {
      name: 'radiooval',
      label: 'Optionskasten  ',
      type: 'radio',
      value: 'Wert1',
      options: [
        { label: 'option 1', value: 'Wert1', checked: true },
        { label: 'option 2', value: 'Wert2', checked: false },
      ],
      settings: {
        layoutItem: false,
        required: true,
        disabled: false,
        appearance: 'oval',
        prefilled: true,
        tooltip: '',
      },
    },
  },
  {
    name: 'radiocard',
    caption: 'Optionskarten',
    icon: './checkboxcard.svg',
    visibility: 'everyone',
    element: {
      name: 'radiocard',
      label: 'Optionskarten',
      type: 'radio',
      value: 'Wert1',
      options: [
        {
          label: 'option 1',
          value: 'Wert1',
          description: null,
          img: '',
          linkType: null,
          checked: true,
          modalConfig: {
            jsonContent: null,
            htmlContent: null,
            margin: 'small-margin',
            modalLink: 'Mehr Infos',
          },
        },
        {
          label: 'option 2',
          value: 'Wert2',
          description: null,
          img: '',
          linkType: null,
          checked: false,
          modalConfig: {
            jsonContent: null,
            htmlContent: null,
            margin: 'small-margin',
            modalLink: 'Mehr Infos',
          },
        },
      ],
      settings: {
        appearance: 'card',
        description: null,
        required: true,
        prefilled: true,
        disabled: false,
        isImgShowInBackGround: false,
        isShowTitleAndDescription: false,
        optionModalPosition: 'middle',
        layoutItem: false,
        sizeSettingValue: 'large',
        imagePosition: 'center',
        customSize: {
          width: 218,
          height: 181,
        },
        tooltip: '',
      },
    },
  },
  {
    name: 'checkbox',
    caption: 'Kontrollkästchen',
    icon: './checkbox.svg',
    visibility: 'everyone',
    element: {
      name: 'kontrollk',
      label: 'Kontrollkästchen ',
      type: 'checkbox',
      value: ['Wert1'],
      options: [
        { label: 'option 1', value: 'Wert1', checked: true },
        { label: 'option 2', value: 'Wert2', checked: false },
      ],
      settings: {
        layoutItem: false,
        min: 1,
        max: 2,
        showVerticle: true,
        tooltip: '',
      },
    },
  },
  {
    name: 'checkboxoval',
    caption: 'Kontrollkasten',
    icon: './radiocard.svg',
    visibility: 'everyone',
    element: {
      name: 'checkboxoval',
      label: 'Kontrollkasten  ',
      type: 'checkbox',
      value: ['Wert1'],
      options: [
        { label: 'option 1', value: 'Wert1', checked: true },
        { label: 'option 2', value: 'Wert2', checked: false },
      ],
      settings: {
        layoutItem: false,
        required: true,
        disabled: false,
        appearance: 'oval',
        min: 1,
        max: 2,
        tooltip: '',
      },
    },
  },
  {
    name: 'checkboxcard',
    caption: 'Kontrollkarten',
    icon: './checkboxcard.svg',
    visibility: 'everyone',
    element: {
      name: 'checkboxcard',
      label: 'Kontrollkarten',
      type: 'checkbox',
      value: ['Wert1'],
      options: [
        {
          label: 'option 1',
          value: 'Wert1',
          description: null,
          img: '',
          linkType: null,
          checked: true,
          modalConfig: {
            jsonContent: null,
            htmlContent: null,
            margin: 'small-margin',
            modalLink: 'Mehr Infos',
          },
        },
        {
          label: 'option 2',
          value: 'Wert2',
          description: null,
          img: '',
          linkType: null,
          checked: false,
          modalConfig: {
            jsonContent: null,
            htmlContent: null,
            margin: 'small-margin',
            modalLink: 'Mehr Infos',
          },
        },
      ],
      settings: {
        appearance: 'card',
        description: null,
        min: 1,
        max: 2,
        required: true,
        disabled: false,
        isImgShowInBackGround: false,
        isShowTitleAndDescription: false,
        optionModalPosition: 'middle',
        layoutItem: false,
        sizeSettingValue: 'large',
        imagePosition: 'center',
        customSize: {
          width: 218,
          height: 181,
        },
        tooltip: '',
      },
    },
  },
  {
    name: 'select',
    caption: 'Dropdown-Menü',
    icon: './dropdown-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'dropdownmenu',
      label: 'Dropdown-Menü  ',
      type: 'select',
      value: '',
      options: [
        { label: 'Auswahl 1', value: 'Wert1' },
        { label: 'Auswahl 2', value: 'Wert2' },
      ],
      settings: {
        required: true,
        disabled: false,
        searchEnabled: false,
        layoutItem: false,
        tooltip: '',
      },
    },
  },
  {
    name: 'model',
    caption: 'Model',
    icon: './database-model.svg',
    visibility: 'admin',
    element: {
      name: 'model',
      label: 'Model  ',
      type: 'model',
      value: 'model-id',
      settings: {
        placeholder: '',
        required: true,
        default: false,
        disabled: false,
        layoutItem: false,
      },
    },
  },
  {
    name: 'html',
    caption: 'html',
    icon: './html.svg',
    visibility: 'admin',
    element: {
      name: 'html',
      label: 'HTML ',
      type: 'html',
      value: '<div>Beispieldiv</div>',
      settings: {
        isHtmlRendered: false,
        layoutItem: true,
      },
    },
  },
  {
    name: 'audioinput',
    caption: 'Audio',
    icon: './input-text-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'audioinput',
      label: 'Audio',
      type: 'audioinput',
      value: '',
      settings: {
        description: null,
        required: false,
        disabled: false,
        targetElementName: '',
        language:
          (typeof navigator !== 'undefined' && navigator.language) || 'de-DE',
        silenceTimeoutMs: 3000,
        layoutItem: true,
        tooltip: '',
      },
    },
  },
  {
    name: 'toggleswitch',
    caption: 'Kippschalter',
    icon: './toggle-switch.svg',
    visibility: 'everyone',
    element: {
      name: 'toggleswitch',
      label: 'Kippschalter  ',
      type: 'toggleswitch',
      value: true,
      settings: {
        layoutItem: false,
        prefilled: true,
        prefixIcon: { icon: null, linkType: null },
        tooltip: '',
      },
    },
  },
  {
    name: 'togglelist',
    caption: 'Klappliste',
    icon: './toggle.svg',
    visibility: 'everyone',
    element: {
      name: 'togglelist',
      label: 'Klappliste',
      type: 'togglelist',
      settings: {
        layoutItem: true,
      },
    },
  },
  {
    name: 'grid',
    caption: '2 Columns',
    icon: './two-col-grid-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'grid',
      label: 'Grid',
      type: 'grid',
      gridStructure: { cols: [{}, {}] },
      settings: {
        layoutItem: true,
      },
    },
  },
  {
    name: 'grid',
    caption: '3 Columns',
    icon: './three-col-grid-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'grid',
      label: 'Grid',
      type: 'grid',
      gridStructure: { cols: [{}, {}, {}] },
      settings: {
        layoutItem: true,
      },
    },
  },
  {
    name: 'grid',
    caption: '4 Columns',
    icon: './four-col-grid-icon.svg',
    visibility: 'everyone',
    element: {
      name: 'grid',
      label: 'Grid',
      type: 'grid',
      gridStructure: { cols: [{}, {}, {}, {}] },
      settings: {
        layoutItem: true,
      },
    },
  },
  {
    name: 'wrapper',
    caption: 'Wrapper',
    icon: './toggle.svg',
    visibility: 'everyone',
    element: {
      name: 'wrapper',
      label: 'Wrapper',
      type: 'wrapper',
      settings: {
        layoutItem: true,
        tag: 'div',
        attributes: [{ key: '', value: '' }],
      },
    },
  },
  {
    name: 'resultframe',
    caption: 'Ergebnis-Iframe',
    icon: './result-element.svg',
    visibility: 'everyone',
    element: {
      name: 'resultframe',
      label: 'Ergebnis-Iframe',
      type: 'resultframe',
      settings: {
        layoutItem: true,
        required: false,
        default: true,
      },
    },
  },
];

export const FORM_VALIDATION_MODES = {
  JUMP_TO_INVALID: 'jump-to-invalid',
  ERROR_SUMMARY: 'error-summary',
};

export const ELEMENTS_ENUM = {
  FORM_TITLE: 'formTitle',
  FORM_FILE: 'formFile',
  FORM_INPUT: 'formInput',
  FORM_TEXTAREA: 'formTextarea',
  FORM_OPTION_CARD: 'formOptionCard',
  FORM_TOGGLE_SWITCH: 'formToggleSwitch',
  FORM_HTML: 'formHtml',
  FORM_OPTION: 'formOption',
  FORM_SELECT: 'formSelect',
  FORM_KLAPP_LIST: 'formToggleList',
  FORM_TEXTBLOCK: 'formTextblock',
  FORM_FORMATTED_INPUT: 'formFormattedInput',
  FORM_AUDIO_INPUT: 'formAudioInput',
  FORM_MAIN: 'formMain',
  FORM_WRAPPER: 'formWrapper',
  FORM_RESULT_FRAME: 'formResultFrame',
};

export const ADDITIONAL_SETTINGS_ENUM = {
  PLACEHOLDER: 'placeholder',
  TABINDEX: 'Tabindex',
  PATTERN: 'pattern',
  ERROR_MESSAGE: 'errorMessage',
  MIN_MAX: 'min_max',
  SELECT: 'select',
  DECIMAL_PLACE: 'decimal_place',
  FORMAT_NUMBER: 'formatNumber',
  DESCRIPTION: 'description',
  TOOLTIP: 'tooltip',
};
